import { APIClient } from '@frontend/api-utils';

const endpoint = '/workflow-service/api/v1';
export class WorkflowTriggerClient extends APIClient {
    public static async fetchWorkflowTriggers(): Promise<{ [key: string]: string }> {
        const response = await this.fetch(`${endpoint}/workflow-triggers`);
        return await this.handleResponse(response);
    }
}
